import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Loader from "components/loader/Loader";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { deleteSinglePet, getUserPets } from "redux-store/pets/pet.slice";
import { AppDispatch } from "redux-store/store";

type Props = {
  handlePetModelClose?: any;
  open?: any;
  pets?: any;
  userId?: any;
  loading?: boolean;
};

const PetDetailsModel = ({ handlePetModelClose, open, pets, userId }: Props) => {
  const dispatch = useDispatch<AppDispatch>();

  const navigate = useNavigate();
  const [loading, setLoading] = useState("");
  const handleEdit = (id: string) => {
    navigate(`/admin/pets/pet-details/${id}`);
  };
  const handleAdd = () => {
    navigate(`/admin/add-pet/${userId}`);
  };

  const handleDelete = (id: string) => {
    setLoading(id);
    dispatch(deleteSinglePet(id)).then((res) => {
      alert(res.payload.message);
      if (res.payload.message) {
        dispatch(getUserPets(userId));
        setLoading("");
      }
    });
    setLoading("");
  };

  function calculateAge(birthdate: any) {
    const today = new Date();
    const birthDate = new Date(birthdate);

    let ageYears = today.getFullYear() - birthDate.getFullYear();
    let ageMonths = today.getMonth() - birthDate.getMonth();

    if (
      today.getMonth() < birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
    ) {
      ageYears--;
      ageMonths += 12;
    }

    return { years: ageYears, months: ageMonths };
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handlePetModelClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <div className="tw-pt-4 tw-flex tw-justify-end tw-px-4">
          <button
            onClick={() => handleAdd()}
            className="tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[blue] tw-py-2 tw-px-8 tw-rounded-md"
          >
            Add Pet
          </button>
        </div>
        <div className="tw-flex tw-flex-col tw-gap-3 tw-py-10">
          {loading ? (
            <Loader />
          ) : pets?.length !== 0 && pets ? (
            pets.map((pet: any, i: any) => (
              <div
                key={pet._id}
                className="tw-w-[80%] tw-mx-auto tw-bg-white tw-py-6 tw-shadow-small tw-rounded-[1rem]"
              >
                <DialogTitle id="alert-dialog-title">{pet?.petName}</DialogTitle>
                <DialogContent className="no-scrollbar scroll_n">
                  <div className="tw-flex tw-flex-col tw-gap-3 tw-mt-2">
                    <div className="tw-relative tw-flex tw-justify-between tw-items-center">
                      <div className="tw-font-bold">Pet Breed</div>
                      <div>{pet?.petBreed}</div>
                    </div>
                    <div className="tw-relative tw-flex tw-justify-between tw-items-center">
                      <div className="tw-font-bold">Pet Gender</div>
                      <div>{pet?.petGender}</div>
                    </div>
                    <div className="tw-relative tw-flex tw-justify-between tw-items-center">
                      <div className="tw-font-bold">Pet Weight</div>
                      <div>{pet?.petWeight}</div>
                    </div>
                    <div className="tw-relative tw-flex tw-justify-between tw-items-center">
                      <div className="tw-font-bold">Pet Age</div>
                      <div>{`${calculateAge(pet?.birthDate).years}y ${calculateAge(pet?.birthDate).months}m`}</div>
                    </div>
                    <div className="tw-relative tw-flex tw-justify-between tw-items-center">
                      <div className="tw-font-bold">Cancer Suspicion</div>
                      <div>{`${pet?.cancerSuspicion ? "YES" : "NO"}`}</div>
                    </div>
                    <div className="tw-flex">{pet?.medicalChart}</div>

                    <div className="tw-flex tw-justify-end tw-gap-5 tw-mt-5">
                      <button
                        onClick={() => handleEdit(pet._id)}
                        className="tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[blue] tw-py-2 tw-px-8 tw-rounded-md"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(pet._id)}
                        className="tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[#FF7B6D] tw-py-2 tw-px-4 tw-rounded-md"
                      >
                        {loading === pet._id ? "Deleting..." : "Delete"}
                      </button>
                    </div>
                  </div>
                </DialogContent>
              </div>
            ))
          ) : (
            <span className="tw-ml-12 tw-text-md">No Pet Found</span>
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default PetDetailsModel;
